import React from 'react';
import { Box, Grid } from 'core/components';
import SiteLink from 'app/components/links/SiteLink';

export default function DeviceProperties({ model, ...containerProps }) {
  return (
    <Grid gridTemplateColumns="auto auto" {...containerProps}>
      <Box color="muted">IP Address</Box>
      <Box>{model.sendingIpsDisplay}</Box>

      <Box color="muted">Site</Box>
      <Box>
        <SiteLink siteId={model.get('site_id')}>{model.get('site_name')}</SiteLink>
      </Box>

      {model.hasVendor && (
        <>
          <Box color="muted">Model</Box>
          <Box>
            {model.get('device_vendor_type')} {model.get('device_model_type')}
          </Box>
        </>
      )}

      <Box color="muted">Sample Rate</Box>
      <Box>1:{model.get('device_sample_rate')}</Box>

      <Box color="muted">Machine Type</Box>
      <Box>{model.deviceType}</Box>

      <Box color="muted">Device ID</Box>
      <Box>{model.id}</Box>
    </Grid>
  );
}
